import { List, Record } from 'immutable';
import { schema } from 'normalizr';

import { relayLoadSchema } from '@sophocles/entities/RelayLoad';
import { relayScheduleSchema } from '@sophocles/entities/RelaySchedule';

export const Relay = new Record({
  id: undefined,
  relay_number: undefined,
  relay_controller: undefined,
  secondary_relay: undefined,
  load_type: undefined,
  normally_closed: false,
  power_measurement_active: true,
  threshold: 180,
  voltage: 120.0,
  all_schedules_deactivated: false, // soon to be renamed
  ignore_charting: false,
  relay_loads: List(),
  loads: [], // new holder for the keys
  schedules: [],
  power_state: null,
  polarity: false,
});

export const relaySchema = new schema.Entity('relays', {
  loads: [relayLoadSchema],
  schedules: [relayScheduleSchema],
});
